import { useEffect, useState } from 'react';

function LightboxImage({ src, alt, className = '' }) {
  const [imageState, setImageState] = useState({ src, status: 'loading' });
  const status = imageState.src === src ? imageState.status : 'loading';
  const isLoaded = status === 'loaded';
  const hasError = status === 'error';

  useEffect(() => {
    setImageState({ src, status: 'loading' });
  }, [src]);

  return (
    <div
      className="relative flex min-h-[45vh] w-full items-center justify-center overflow-hidden bg-black/25"
      aria-busy={!isLoaded && !hasError}
    >
      {!isLoaded && !hasError && (
        <div className="absolute inset-0 z-10 flex items-center justify-center" role="status">
          <span className="inline-flex items-center gap-3 rounded-full bg-black/60 px-4 py-2 text-sm font-semibold text-white shadow-lg backdrop-blur-sm">
            <span
              className="h-4 w-4 animate-spin rounded-full border-2 border-white/35 border-t-white"
              aria-hidden="true"
            />
            Loading photo
          </span>
        </div>
      )}

      {hasError && (
        <p className="bg-black/65 px-5 py-4 text-center text-sm font-semibold text-white">
          This photo could not be loaded.
        </p>
      )}

      <img
        src={src}
        alt={alt}
        decoding="async"
        onLoad={() => setImageState({ src, status: 'loaded' })}
        onError={() => setImageState({ src, status: 'error' })}
        className={`max-h-[80vh] max-w-full object-contain transition-opacity duration-300 ${
          isLoaded ? 'opacity-100' : 'opacity-0'
        } ${hasError ? 'hidden' : ''} ${className}`}
      />
    </div>
  );
}

export default LightboxImage;
